// @flow
import { COUNTRY_EVENTS } from 'Client/cms/toolkit/constants';
import { CountryEventsLine } from 'Components/lines/country-events-line/CountryEventsLine';
import { countryEventsResolver } from './countryEvents.resolver';

export const countryEventsDescriptor = {
  name: COUNTRY_EVENTS,
  component: CountryEventsLine,
  resolve: countryEventsResolver.resolve,
};
